import adjust from './main.vue'
adjust.install = function (vue) {
  vue.component(adjust.name, adjust)
}
export default adjust



// WEBPACK FOOTER //
// ./src/ui/components/adjust/index.js